import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { NDDTranslationService } from '@ndk/ng-translation';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICoreConfigInternal } from '@core/core.config.model';
import { LoggerService } from '@core/logger/logger.service';
import { QuotaObjectTypes } from '@features/quota/shared/quota-object-types.enum';

@Injectable()
export class SettingsQuotasTypeService {
    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
        private loggerService: LoggerService,
        private translation: NDDTranslationService,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/settings-quotas`;
    }

    /**
     * Verifica o tipo de cota (Usuários, Compartilhadas ou Impressoras) baseando-se no retorno do parâmetro "QuotasObjectType",
     * @returns {Observable<QuotasObjectType>} `Users` para Cotas por Usuários, `Shared` para Cotas Compartilhadas e `Printers` para impressora.
     */
    public getType(): Observable<QuotaObjectTypes> {
        return this.http.get<QuotaObjectTypes>(`${ this.apiUrl }/type`);
    }

    public updateType(quotaType: QuotaObjectTypes): Observable<boolean> {
        const command: any = { quotaType };

        return this.http.post<boolean>(`${ this.apiUrl }/type`, command)
            .pipe(tap((result: boolean) => {
                this.loggerService.success(true, [this.translation.instant('360SettingsSuccess')]);
            }));
    }
}
